<template>
    <div class="mx-auto my-2">
        <!-- 按鈕們 -->
        <div class="MemberBtnGroup d-flex justify-content-between mt-2" >
            <!-- 會員資料 -->
            <div class="d-flex flex-column MemberBtn " @click="GoMemberInfo()">
                <font-awesome-icon class="icon" :icon="['far','user']" size="3x"/>
                <span>會員資料</span>
            </div>
            <!-- 報價單查詢 -->
            <div class="d-flex flex-column MemberBtn" @click="GoEstimateListPage()">
                <font-awesome-icon class="icon" :icon="['fas','magnifying-glass-dollar']" size="3x"/>
                <span>報價單查詢</span>
            </div>
            <!-- 報名表查詢 -->
            <div class="d-flex flex-column MemberBtn" @click="GoRegistrationListPage()">
                <font-awesome-icon class="icon" :icon="['far','file-lines']" size="3x"/>
                <span>報名表查詢</span>
            </div>
            <!-- HiQuiz -->
            <div class="d-flex flex-column MemberBtn" @click="openHiQuiz()">
                <font-awesome-icon class="icon" :icon="['fas','file-pen']" size="3x"/>
                <span>HiQuiz</span>
            </div>
        </div>
        <div class="MemberBtnGroup d-flex justify-content-between mt-2">
            <!-- 特約商店 -->
            <div class="d-flex flex-column MemberBtn" @click="GoStoresListPage()">
                <font-awesome-icon class="icon" :icon="['fas','fa-store']" size="3x"/>
                <span>特約商店</span>
            </div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

export default {
    name: 'MemberButtons',
    components:{
        Nav,
    },
    data () {
        return {
            Token:'',
            userId:'',
            HiQuizDemoUrl:'http://hiquizdemo.hitutor.com.tw/',
            HiQuizMasterUrl:'http://hiquiz.hi-tr.com/',
        }
    },
    mounted(){
        
    },
    methods:{
        GoMemberInfo(){
            this.$router.push({
                name: 'MemberInfo',
            });
        },
        GoEstimateListPage(){
            this.$router.push({
                name: 'EstimateList',
            });
        },
        GoRegistrationListPage(){
            this.$router.push({
                name: 'RegistrationList',
            });
        },
        openHiQuiz(){
            var url = '';
            if(`${process.env.NODE_ENV}` == "production"){//master
                url = this.HiQuizMasterUrl + '?token=' + this.Token + '&userId=' + this.userId;
            }else{ //demo
                // url = this.HiQuizDemoUrl + '?token=' + this.Token + '&userId=' + this.userId;
                url = 'http://hiquizdemo.hitutor.com.tw/?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0ZXN0MTYxMDI2ZGRAa2sudHQiLCJuYW1laWQiOiI3MTIzMCIsInR5cCI6IlMiLCJlbWFpbCI6InRlc3QxNjEwMjZkZEBray50dCIsIm5iZiI6MTY4MDA3NDM3MywiZXhwIjoxNzExNjk2NzczLCJpYXQiOjE2ODAwNzQzNzMsImlzcyI6IkhpVHV0b3IifQ.JEeMw3uvwHNC0P5yKsxb_H4PB_CZkgaakWhtyFOPpVo&userId=71230'
            }
            this.$root.$refs.home.GoHiQuiz(url)
            // window.location.href =url;
        },
        GoStoresListPage(){
            this.$router.push({
                name: 'StoresList',
            });
        },
    },
    created(){
        this.Token  =JSON.parse(sessionStorage.getItem('UserData')).token;
        this.userId  =JSON.parse(sessionStorage.getItem('UserData')).userId;
    }
}
</script>




// WEBPACK FOOTER //
// src/components/LineComponents/MemberButtons.vue